import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

import { useZones } from 'store/apis';
import { BasicSelector, BasicSelectorProps } from './basic-selector';
import { EZoneStatus } from '../../enums';

type ZoneSelectorProps = BasicSelectorProps & {
  buildingId: number | null;
  value: number | null;
  onChange?: (value: number | null) => void;
};

export const ZoneSelector = ({ buildingId, onChange: _onChange = () => {}, value, ...rest }: ZoneSelectorProps) => {
  const { data: { all: zones = [] } = {}, isFetching } = useZones({ buildingId });
  const label = 'Zone';
  const placeholder = 'Select a Zone...';

  const options = zones.filter((zone) => zone.status === EZoneStatus.ACTIVE).map(({ id }) => id);
  const getOptionLabel = (option: number) => {
    const { name = '', code = '', floorInfo = '' } = zones.find(({ id }) => id === option) || {};
    return `${name} - ${floorInfo}: #${code}`;
  };
  const onChange: any = (_: any, value: number) => _onChange(value);
  const renderOption = (props: any, option: number) => {
    const { name = '', code = '', floorInfo = '' } = zones.find(({ id }) => id === option) || {};

    return (
      <Box {...props} flexDirection={'column'}>
        <Grid container spacing={1} justifyContent="space-between">
          <Grid item>
            <Typography sx={{ textAlign: 'left', width: '100%' }}>{name}</Typography>
          </Grid>
          <Grid item>
            <Typography variant="caption" color="textSecondary">
              {floorInfo}:{' '}
            </Typography>

            <Typography variant="caption" color="primary">
              #{code}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const componentProps: Partial<ZoneSelectorProps> = {
    label,
    placeholder,
    value,
    options,
    getOptionLabel,
    renderOption,
    onChange,
    optionsConfig: false,
    loading: isFetching,
    optionsLoadingText: 'Loading zones...',
    noOptionsText: 'No zone',
  };

  return <BasicSelector {...componentProps} {...rest} />;
};
